import { render } from "./OrganizersCreating.vue?vue&type=template&id=883234d2&ts=true"
import script from "./OrganizersCreating.vue?vue&type=script&lang=ts"
export * from "./OrganizersCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__